import { useQuery } from '@tanstack/react-query';
import type { TaxonomyLocale } from '@tabbio/types';
import { QUERY_KEYS } from '../lib/query-keys';
import {
  fetchCatalogRoles,
  fetchCatalogSkills,
  normalizeSkillsApi,
} from '../lib/taxonomy-api';

function serializeTaxonomyParams(query?: string, limit?: number) {
  return JSON.stringify({
    query: query?.trim() ?? '',
    limit: limit ?? 24,
  });
}

export function useCatalogSkills(
  query = '',
  limit = 24,
  enabled = true,
) {
  return useQuery({
    queryKey: QUERY_KEYS.TAXONOMY_SKILLS(serializeTaxonomyParams(query, limit)),
    queryFn: () => fetchCatalogSkills(query, limit),
    enabled,
    staleTime: 60_000,
  });
}

export function useCatalogRoles(
  query = '',
  limit = 24,
  enabled = true,
) {
  return useQuery({
    queryKey: QUERY_KEYS.TAXONOMY_ROLES(serializeTaxonomyParams(query, limit)),
    queryFn: () => fetchCatalogRoles(query, limit),
    enabled,
    staleTime: 60_000,
  });
}

export function useNormalizeSkills(
  skills: string[],
  locale?: TaxonomyLocale,
  enabled = true,
) {
  const sortedKey = JSON.stringify({
    skills: [...skills].sort(),
    locale: locale ?? 'en',
  });
  return useQuery({
    queryKey: QUERY_KEYS.TAXONOMY_NORMALIZE_SKILLS(sortedKey),
    queryFn: () => normalizeSkillsApi(skills, locale),
    enabled: enabled && skills.length > 0,
    staleTime: 60_000,
  });
}

